module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAVCAYAAACdbmSKAAAA8UlEQVQ4T5XSMQ6DMAwAQBsE6hN4AmPHjh0ZO3aMBPgNHXlGRRSJJzAyduzIM/qEiihQBQGigkDwGp/s2EYiurVtGyJixTmvwSKQiB4AcNK5XdeVNhDTND0j4m0sYANRJw8wGisqpd5CiMrUaY90MMYC3/fZDNZCiHINTugI/EO2cIFMUClVFUXx1e+raIAnz/MYIgbDOj5SykJDIzJBzvlzE2lIRCEA3Mcp5nmebSLT4o1o61JW0d5pLdAeWIzcBvwhWzChJEmujuNch7F+m6bRS/wYrzyO48h13Yst6CsRUXYE9Ej/BQBCKeVrq6V5qz/ntq8WwqfKJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/imgages/you.png
// module id = /t9w
// module chunks = 1